import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import styles from './Stepper.module.scss';

export interface StepperStep {
    id: string;
    label: string;
}

interface StepperProps {
    steps: Array<StepperStep>;
    currentIndex: number;
    maxReachedIndex: number;
    onStepClick?: (index: number) => void;
    className?: string;
}

// Horizontal wizard stepper: black = current, green check = done, grey = pending.
export const Stepper: React.FC<StepperProps> = ({ steps, currentIndex, maxReachedIndex, onStepClick, className }) => (
    <ol className={clsx(styles.root, className)}>
        {steps.map((step, index) => {
            const isCurrent = index === currentIndex;
            const isDone = index < currentIndex || (index <= maxReachedIndex && !isCurrent);
            const isReachable = index <= maxReachedIndex && !isCurrent;

            return (
                <li
                    key={step.id}
                    className={styles.item}
                >
                    {index > 0 && (
                        <span className={clsx(styles.line, { [styles.lineDone]: index <= maxReachedIndex })} />
                    )}
                    <button
                        type="button"
                        disabled={!isReachable}
                        className={clsx(styles.step, {
                            [styles.current]: isCurrent,
                            [styles.done]: isDone,
                            [styles.reachable]: isReachable
                        })}
                        onClick={() => isReachable && onStepClick?.(index)}
                    >
                        <span className={styles.bubble}>{isDone ? <FontAwesomeIcon icon={faCheck} /> : index + 1}</span>
                        <span className={styles.label}>{step.label}</span>
                    </button>
                </li>
            );
        })}
    </ol>
);

export default Stepper;
